/**
 * Theme picker submenu.
 *
 * A submenu component for selecting theme preference (Light/Dark/System).
 * Designed to be composed within a parent Menu.
 */

import { monitor } from "@animus/iconic-svg/icons/monitor";
import { moon } from "@animus/iconic-svg/icons/moon";
import { sun } from "@animus/iconic-svg/icons/sun";
import { Icon, Menu } from "@animus/primaris";

import type { ThemePreference } from "../theme-preferences/types";
import { useThemeStore } from "../theme-preferences/store";

const THEME_OPTIONS: Array<{
  value: ThemePreference;
  label: string;
  icon: string;
}> = [
  { value: "light", label: "Light", icon: sun },
  { value: "dark", label: "Dark", icon: moon },
  { value: "system", label: "System", icon: monitor },
];

function getCurrentThemeIcon(preference: ThemePreference): string {
  switch (preference) {
    case "light":
      return sun;
    case "dark":
      return moon;
    default:
      return monitor;
  }
}

export function ThemePickerSubmenu() {
  const { preference, setPreference } = useThemeStore();

  return (
    <Menu.SubMenu id="theme">
      <Menu.SubMenuTrigger
        icon={<Icon size="xs" svg={getCurrentThemeIcon(preference)} />}
        label="Theme"
      />
      <Menu.SubMenuContent>
        {THEME_OPTIONS.map((option) => (
          <Menu.MenuItem
            active={preference === option.value}
            icon={<Icon size="xs" svg={option.icon} />}
            key={option.value}
            onSelect={() => setPreference(option.value)}
            showCheckmark
          >
            {option.label}
          </Menu.MenuItem>
        ))}
      </Menu.SubMenuContent>
    </Menu.SubMenu>
  );
}
